<app-media-page
  [loading]="loading"
  [medias]="medias$ | async"
  [hasNextPage]="hasNextPage"
  title="Reprendre la lecture"
  color="blue"
></app-media-page>
